import { useState } from "react";
import { FILTERS } from "./fixtures";

export interface UseJobHistorySearchFilters {
  mode: "default" | "search";
  setMode: (value: "default" | "search") => void;
  search: string;
  setSearch: (value: string) => void;
  filters: string[];
  setFilters: (value: string[]) => void;
}

export const useJobHistorySearchFilters = () => {
  const [mode, setMode] = useState<"default" | "search">("default");
  const [search, setSearch] = useState<string>("");
  const [filters, setFilters] = useState<string[]>(Object.keys(FILTERS));
  
  return {
    mode,
    setMode,
    search,
    setSearch,
    filters,
    setFilters,
  } satisfies UseJobHistorySearchFilters;
};
